import Cookies from "js-cookie";

export const REFERRAL_COOKIE = "bs_referral";
const COOKIE_OPTIONS = {
  expires: 60, // days
  sameSite: "Lax" as const,
  path: "/",
};

export const persistReferralCode = (code: string) => {
  const trimmed = code?.trim();
  if (!trimmed) {
    return;
  }
  Cookies.set(REFERRAL_COOKIE, trimmed, COOKIE_OPTIONS);
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.setItem(REFERRAL_COOKIE, trimmed);
    } catch {
      // Ignore storage quota/privacy mode issues.
    }
  }
};

export const readReferralCode = (): string | null => {
  const value = Cookies.get(REFERRAL_COOKIE);
  if (value?.trim()) {
    return value.trim();
  }
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const stored = window.localStorage.getItem(REFERRAL_COOKIE);
      return stored?.trim() || null;
    } catch {
      return null;
    }
  }
  return null;
};

export const clearReferralCode = () => {
  Cookies.remove(REFERRAL_COOKIE);
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.removeItem(REFERRAL_COOKIE);
    } catch (storageError) {
      console.warn("referral.clear_cookie_failed", storageError);
    }
  }
};

// ─────────────────────────────────────────────────────────────────────────────
//  New helpers with explicit cookie name (from backend settings)
// ─────────────────────────────────────────────────────────────────────────────
export const persistReferralCodeWith = (cookieName: string, code: string) => {
  const trimmed = code?.trim();
  const name = (cookieName || REFERRAL_COOKIE).trim() || REFERRAL_COOKIE;
  if (!trimmed) return;
  Cookies.set(name, trimmed, COOKIE_OPTIONS);
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.setItem(name, trimmed);
    } catch (storageError) {
      console.warn("referral.persist_failed", storageError);
    }
  }
};

export const readReferralCodeWith = (cookieName: string): string | null => {
  const name = (cookieName || REFERRAL_COOKIE).trim() || REFERRAL_COOKIE;
  const value = Cookies.get(name);
  if (value?.trim()) return value.trim();
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const stored = window.localStorage.getItem(name);
      return stored?.trim() || null;
    } catch {
      return null;
    }
  }
  return null;
};

export const clearReferralCodeWith = (cookieName: string) => {
  const name = (cookieName || REFERRAL_COOKIE).trim() || REFERRAL_COOKIE;
  Cookies.remove(name);
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.removeItem(name);
    } catch (storageError) {
      console.warn("referral.clear_with_failed", storageError);
    }
  }
};
